import { Flex } from 'antd';
import styles from './check-email.module.scss';
import { Button } from '../button/button';
import Icon from '@ant-design/icons';
import Mail from '@/assets/icons/mail-01.svg?react';

import { useEffect, useState } from 'react';
import { calculateSecondsToMinutes, countSeconds } from '@/utils/helpers';
import { START_TIME } from './check-email.constant';

interface CheckEmailProps {
  email: string;
  onResendEmail: () => void;
  showEmailInput: () => void;
}

export function CheckEmail({ email, onResendEmail, showEmailInput }: CheckEmailProps) {
  const [time, setTime] = useState(START_TIME);
  const disableResending = time !== 0;
  const enableResending = time === START_TIME;

  useEffect(() => {
    countSeconds(setTime, time);
  }, [enableResending]);

  return (
    <Flex className={styles.container} vertical gap={24} align="center" justify="center">
      <Flex className={styles.iconContainer} align="center" justify="center">
        <Icon
          className={styles.mail}
          component={() => <Mail width={24} height={24} stroke={styles.iconColor} />}
        />
      </Flex>
      <h3 className={styles.title}>Check your email</h3>
      <p className={styles.paragraph}>
        Please check the email address <span className={styles.bold}>{email}</span> for instructions
        to reset your password.
      </p>
      <Button
        onClick={() => {
          onResendEmail();
          setTime(START_TIME);
        }}
        disabled={disableResending}
        className={styles.button}
      >
        Resend email {disableResending ? `in ${calculateSecondsToMinutes(time)}` : ''}
      </Button>
      <p className={styles.paragraph}>
        Is {email} not your email address?{' '}
        <Button buttonVariant="tertiary" className={styles.changeEmailButton} onClick={showEmailInput}>
          Change email
        </Button>
      </p>
    </Flex>
  );
}
